<template>
  <BgImageLayout title="Ip Addresses" icon-color="white">
    <ConfirmationDialog
      ref="confirmDialog"
      confirm-label="Yes, delete"
      confirm-btn-type="danger"
      cancel-label="no, cancel"
    />
    <CreateUpdateModal ref="createUpdateModal" @updated="ipAddressUpdated" @created="ipAddressCreated" />

    <q-table
      :data="data"
      :columns="columns"
      :pagination.sync="pagination"
      :loading="tableLoading"
      loading-label="Fetching ip addresses"
      row-key="name"
      class="table"
      wrap-cells
    >
      <template #top-right>
        <div class="row flex-center fit">
          <q-btn size="sm" color="tertiary text-right" @click="openCreateModal">
            Create New
          </q-btn>
        </div>
      </template>

      <template #body-cell-actions="props">
        <q-td :props="props" style="min-width: 100px">
          <q-btn round flat size="sm" icon="fas fa-pen" @click="openEditModal(props.row)" />
          <q-btn round flat size="sm" icon="fas fa-trash" @click="onDelete(props.row)" />
        </q-td>
      </template>
    </q-table>
  </BgImageLayout>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
// Components
import CreateUpdateModal from './components/CreateUpdateModal.vue'
import ConfirmationDialog from '@/ui/ConfirmationDialog.vue'

export default {
  components: {
    ConfirmationDialog,
    CreateUpdateModal
  },

  data: () => ({
    pagination: {
      rowsPerPage: 30
    },
    data: [],
    tableLoading: false
  }),

  computed: {},

  created() {
    this.columns = [
      {
        name: 'ip_address',
        required: true,
        label: 'Ip Address',
        align: 'left',
        field: 'ip_address'
      },
      {
        name: 'provider',
        field: 'provider',
        label: 'Provider',
        align: 'left',
        /** @param {IpAddressResponse.provider} val */
        format: val => `${val.name}`
      },
      {
        name: 'location',
        label: 'Location',
        align: 'left',
        field: 'location',
        format: val => `${val ?? 'N/A'}`
      },
      {
        name: 'description',
        label: 'Description',
        align: 'left',
        field: 'description',
        format: val => `${val ?? 'N/A'}`
      },
      {
        name: 'ip_range',
        label: 'Ip Range',
        align: 'left',
        field: 'ip_range',
        format: val => `${val ?? 'N/A'}`
      },
      {
        name: 'should_be_dispatched',
        label: 'Notify provider',
        align: 'left',
        field: row => (row.should_be_dispatched ? 'Yes' : 'No')
      },

      {
        align: 'center',
        name: 'actions',
        label: 'Actions'
      }
    ]
    this.getAddresses()
  },

  methods: {
    getAddresses() {
      this.tableLoading = true
      apiTo
        .IP_ADDRESSES()
        .then(({ data }) => (this.data = data.result))
        .finally(() => (this.tableLoading = false))
    },

    openCreateModal() {
      this.$refs.createUpdateModal.show()
    },

    openEditModal(ipAddress) {
      this.$refs.createUpdateModal.show(ipAddress)
    },

    /** @param {IpAddressResponse} ipAddress */
    onDelete(ipAddress) {
      const dialog = this.$refs.confirmDialog.show({
        title: `Are you sure you want to delete the IP Address ${ipAddress.ip_address}?`
      })
      dialog.onCancel(hide => hide())
      dialog.onConfirm((hideModal, setModalLoading) => {
        setModalLoading()
        apiTo
          .IP_ADDRESSES_DELETE(ipAddress.id)
          .then(() => {
            this.data = this.data.filter(({ id }) => id !== ipAddress.id)
            hideModal()
          })
          .finally(() => setModalLoading(false))
      })
    },

    ipAddressUpdated(updatedIpAddress) {
      const index = this.data.findIndex(({ id }) => id === updatedIpAddress.id)
      if (index !== -1) {
        this.data.splice(index, 1, updatedIpAddress)
      }
    },

    ipAddressCreated(createdIpAddress) {
      this.data.unshift(createdIpAddress)
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  background: white;
  td {
    height: 48px;
  }
}
</style>
